import React from 'react';
import { withTranslation } from 'react-i18next';
import { useDrop } from 'react-dnd';
import { ItemTypes } from './Helpers/ItemTypes';
import {
  MultiShape,
  SquareShape,
  CircleShape,
  LiveTrendChartShape,
} from './Helpers';

function MapDrawingZone({ bg, shapeArr, selectedShape, ...props }) {
  const moveShape = React.useCallback(
    (id, left, top) => {
      props.onDragShape(id, left, top);
    },
    [shapeArr],
  );

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.SHAPE,
      drop(item, monitor) {
        const delta = monitor.getDifferenceFromInitialOffset();
        let left = Math.round(item.position.left + delta.x);
        let top = Math.round(item.position.top + delta.y);
        // if (snapToGrid) {
        //   [left, top] = doSnapToGrid(left, top);
        // }
        moveShape(item.id, left, top);
        return undefined;
      },
    }),
    [moveShape],
  );
  return (
    <div className="map-drawing-zone" ref={drop} role="DrawingPanel">
      <div className="drawing-zone-bg" onClick={props.onSelectBg}>
        {bg && (
          <img
            src={bg.image.src}
            style={{ ...bg.dimension }}
            alt="map-background"
          />
        )}
      </div>
      {shapeArr &&
        shapeArr.map((shape) => {
          let isSelected = false;
          if (selectedShape && selectedShape.id === shape.id) {
            isSelected = true;
          } else isSelected = false;
          switch (shape.className) {
            case 'Multi':
              return (
                <MultiShape
                  key={shape.id}
                  shape={shape}
                  isSelected={isSelected}
                  onSelectShape={props.onSelectShape}
                />
              );
            case 'Square':
            case 'SquareShape':
              return (
                <SquareShape
                  key={shape.id}
                  shape={shape}
                  isSelected={isSelected}
                  onSelectShape={props.onSelectShape}
                />
              );
            case 'Chart':
              return (
                <LiveTrendChartShape
                  key={shape.id}
                  shape={shape}
                  isSelected={isSelected}
                  onSelectShape={props.onSelectShape}
                />
              );
            default:
              return (
                <CircleShape
                  key={shape.id}
                  shape={shape}
                  isSelected={isSelected}
                  onSelectShape={props.onSelectShape}
                />
              );
          }
        })}
    </div>
  );
}

export default withTranslation('app')(MapDrawingZone);
